import { render, staticRenderFns } from "./UploadDialog.vue?vue&type=template&id=a8ba6b4e"
import script from "./UploadDialog.vue?vue&type=script&lang=ts"
export * from "./UploadDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8ba6b4e')) {
      api.createRecord('a8ba6b4e', component.options)
    } else {
      api.reload('a8ba6b4e', component.options)
    }
    module.hot.accept("./UploadDialog.vue?vue&type=template&id=a8ba6b4e", function () {
      api.rerender('a8ba6b4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UploadDialog.vue"
export default component.exports